import React, { ReactElement } from 'react'
import useStyles from './Footer.styles'

export type FooterProps = { button: ReactElement | null; children?: ReactElement; beforeButton?: ReactElement }

const Footer = ({ button, children, beforeButton }: FooterProps) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      {beforeButton}
      {button && <div className={classes.buttonCont}>{button}</div>}
      {children}
    </div>
  )
}

export default Footer
